export const plural = (count = 0, single, plural) =>
  count > 1 ? plural : single;
